<div class="kr-transfer__header" data-testid="transfer_header">
  <h4 class="kr-transfer__header-text" data-testid="transfer_header_text">
    {{ wallet.name }} / {{ 'transfer.title' | translate }}
  </h4>

  <button
    class="kr-transfer__header-btn-close"
    type="button"
    fuButton
    uiType="quaternary"
    size="m"
    [onlyIcon]="true"
    (click)="close()"
    data-testid="transfer_close_button">
    <fu-icon
      iconName="close-square"
      data-testid="transfer_close_icon"></fu-icon>
  </button>
</div>

<form
  class="kr-transfer__body"
  [formGroup]="form"
  (ngSubmit)="next()"
  data-testid="transfer_form">
  <nav class="kr-tabs" data-testid="transfer_tabs">
    <div
      class="kr-tabs__tab"
      [class.kr-tabs__tab_active]="tab === 'internal'"
      (click)="setTab('internal')"
      translate="transfer.tab.internal"
      data-testid="transfer_tab_internal"></div>

    <div
      class="kr-tabs__tab"
      [class.kr-tabs__tab_active]="tab === 'external'"
      (click)="setTab('external')"
      translate="transfer.tab.external"
      data-testid="transfer_tab_external"></div>
  </nav>

  <div class="kr-transfer__content" data-testid="transfer_content">
    <div
      class="kr-transfer__content-wallet"
      data-testid="transfer_content_wallet">
      <kr-wallet-card
        [wallet]="wallet"
        large
        data-testid="transfer_wallet_card" />

      @if (coinIdOptions) {
        <div
          class="kr-transfer__content-wallet-coins"
          data-testid="transfer_coins">
          <fu-radio-option
            formControlName="coinId"
            controlId="coinId"
            [option]="coinIdOptions.primary"
            data-testid="transfer_coin_primary">
          </fu-radio-option>

          <fu-radio-option
            formControlName="coinId"
            controlId="coinId"
            [option]="coinIdOptions.secondary"
            data-testid="transfer_coin_secondary">
          </fu-radio-option>
        </div>
      }
    </div>

    <fu-icon
      class="kr-transfer__content-icon-arrow"
      iconName="arrow-right-filled"
      size="48"
      data-testid="transfer_arrow_icon">
    </fu-icon>

    <div class="kr-transfer__content-controls" data-testid="transfer_controls">
      @switch (tab) {
        @case ('internal') {
          <fu-select
            formControlName="toWalletId"
            [items]="wallets"
            [label]="'transfer.form.wallets.label' | translate"
            data-testid="transfer_to_wallet_select">
          </fu-select>
        }
        @case ('external') {
          <fu-simple-input
            class="fu-form-container"
            formControlName="address"
            [placeholder]="'transfer.form.wallet.label' | translate"
            [label]="'transfer.form.wallet.label' | translate"
            data-testid="transfer_address_input">
          </fu-simple-input>
        }
      }

      <fu-simple-input
        class="fu-form-container"
        formControlName="amount"
        [errorDictionary]="{
          min:
            'transfer.form.amount.validator.min'
            | translate: { min: walletTransferMinAmount },
          pattern: 'transfer.form.amount.validator.pattern' | translate,
          invalidBalance: 'errors.insufficient.funds' | translate,
          maxDecimals:
            'transfer.form.amount.validator.maxDecimals'
            | translate: { max: walletTransferMaxDecimals },
        }"
        [label]="'transfer.form.amount.label' | translate"
        [placeholder]="
          'transfer.form.amount.placeholder.min'
            | translate: { min: walletTransferMinAmount }
        "
        data-testid="transfer_amount_input">
      </fu-simple-input>

      <fu-text-area
        formControlName="comment"
        [maxLength]="260"
        [rows]="4"
        [placeholder]="'transfer.form.comment.label' | translate"
        [label]="'transfer.form.comment.label' | translate"
        data-testid="transfer_comment">
      </fu-text-area>
    </div>
  </div>

  <div class="kr-actions" data-testid="transfer_actions">
    <button
      type="button"
      fuButton
      size="m"
      uiType="primary"
      (click)="close()"
      translate="transfer.btn.back"
      data-testid="transfer_back_button"></button>

    <button
      type="submit"
      fuButton
      size="m"
      uiType="primary"
      translate="transfer.btn.next"
      data-testid="transfer_next_button"></button>
  </div>
</form>

<ng-template #failedTpl>
  <fu-icon iconName="failed" size="64" data-testid="transfer_failed_icon">
  </fu-icon>

  <h5
    class="kr-transfer-details__message"
    translate="transferDetails.failed.message"
    data-testid="transfer_failed_message"></h5>

  <div
    class="kr-details kr-details_center"
    data-testid="transfer_failed_details">
    <label
      class="kr-details__label"
      translate="transferDetails.failed.label.error"
      data-testid="transfer_failed_label_error">
    </label>

    <span
      class="kr-details__value kr-details_danger"
      data-testid="transfer_failed_error_value">
      {{ errMessage | translate }}
    </span>
  </div>
</ng-template>
